export default __webpack_public_path__ + "static/media/arrow_down.7457e731.svg";